<div class="container-inco new-table-style">
  <div class="header-container">
  </div>

  <mat-tab-group orientation="vertical" mat-stretch-tabs="false" #tabGroup [selectedIndex]="0" [animationDuration]="'0ms'" >
    <mat-tab label="ACT Check">
      <div class="inner-tcontainer-tab">
        <app-act-validation></app-act-validation>
      </div>
    </mat-tab>
    <mat-tab label="OPL Check">
      <div class="inner-tcontainer-tab">
        <app-opl-validation></app-opl-validation>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>